import type { FaireProductEntity } from "../../entity_types/product";

export const p_g3kapurykq: FaireProductEntity = {
  token: "p_g3kapurykq",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE OLIVE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/f223fe9ff1b1927a285e87dd6bb684e31a2f3342288e085d8a1f02f8370e90b1.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:55.502Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
